import Vue from "vue";
import Vuex from "vuex";
import mutations from './mutations.js'

Vue.use(Vuex);
export default new Vuex.Store({
    
    state: {
        apiUrl: '',
        width: '',
        height: '',
        ratio: {
            height: 1,
            width: 1,
            hole: 1
        },
        lock: false,
    },
    mutations: mutations,
    actions: {}
});